'use strict';

module.exports = function () {
  return {
    $get: [
      '$injector',
      'fetchUtils',
      function (
        $injector,
        fetchUtils,
      ) {
        function FeedableMixin(Class) {

          Class.$constraints.addConstraint('feed', {
            type: 'DomainCollection',
            domainClass: 'ActivityFeedDomain',
            link: 'feedable'
          });

          Class.$constraints.addConstraint('subscribers', {
            type: 'DomainCollection',
            domainClass: 'UserDomain'
          });

          Class.subscribe = subscribe;
          Class.unsubscribe = unsubscribe;

          Class.prototype.subscribe = subscribeProto;
          Class.prototype.unsubscribe = unsubscribeProto;
        }

        function subscribe(id, options) {
          const request = {
            method: 'PUT',
            mode: 'cors',
            cache: 'default',
          };
          if (options) {
            request.body = options;
            request.contentType = 'json';
            request.responseType = 'json';
          }

          const url = `${fetchUtils.API_URL}/api/${this.COLLECTION}/${id}/subscription`;
          return fetchUtils.requestWithAuth(url, request);
        }

        function unsubscribe(id) {
          const request = {
            method: 'DELETE',
            mode: 'cors',
            cache: 'default'
          };

          const url = `${fetchUtils.API_URL}/api/${this.COLLECTION}/${id}/subscription`;
          return fetchUtils.requestWithAuth(url, request);
        }

        function subscribeProto(options) {
          return this.$class.subscribe(this.$id, options);
        }

        function unsubscribeProto() {
          return this.$class.unsubscribe(this.$id);
        }

        return FeedableMixin;
      }]
  }
};



// WEBPACK FOOTER //
// ./src/js/core-utilities/domain/FeedableMixin.js